import React, { Component } from 'react'
import { connect } from 'react-redux'
import Layout from '../../layout/GeneralLayout'
import { Box, ResponsiveContext } from 'grommet'
import loadable from '@loadable/component'
// import Snowfall from 'react-snowfall'
import styled, { css } from 'styled-components'
import Inputs from '../../component/Inputs/RTGindex'
import Result from '../../component/ReactRTG'
import Controller from '../../component/ReactRTG/controller'
import ToolType from '../../utils/toolType'
import Footer from '../../component/Footer'
import { device } from '../../theme/device'
// import { syncFirstPeopleList } from '../../redux/rtg/actions'
import RTGSharedImage from '../../images/tools/Team-Picker-Wheel.png'
import SEO from '../../component/SEO'
import withProvider from '../../component/HOC/withProvider'
// import { getShareLink } from '../../redux/shareWheel/actions'
// import SpinnerFullScreen from '../../component/Spinner/SpinnerFullScreen'
// import { rgba } from 'polished'
import PageTitle from '../../component/PageComponent/PageTitle'
import {
  BGContainer,
  ContainerTool,
  FullScreen,
  WheelWhiteBox,
} from '../../component/PageComponent/Box'
// import ToolTitle from '../../component/Title'
import ArticleContent from '../../component/Section/Content'
import SpinnerFullScreen from '../../component/Spinner/SpinnerFullScreen'
import ToolSettings from '../../component/ToolSettings'
import Versioning from '../../component/PageComponent/Versioning'
import withWheelToolHOC from '../../component/HOC/withWheelToolHOC'
import MiddleBox from '../../component/PageComponent/MiddleBox'
import UnhideInputButton from '../../component/Button/UnhideInputButton'
import InputBox from '../../component/PageComponent/InputBox'
import FullScreenButton from '../../component/Button/FullScreenButton'
import InputShield from '../../component/PageComponent/InputShield'
import { RelativeBox } from '../../component/Common'
import VolumeButton from '../../component/Button/VolumeButton'
import { replaceCDN } from '../../utils'
import PresetGroupModal from '../../component/Modals/PresetGroupModal'

// import TeamNameModal from '../../component/Modals/TeamNameModal'

const Modal = loadable(() =>
  import('../../component/Modals/ResultModal/RTGResultModal'),
)
const InputListModal = loadable(
  () => import('../../component/Modals/RTGInputListModal'),
  {
    fallback: <SpinnerFullScreen caption="Please wait..." />,
  },
)
const TeamNameModal = loadable(
  () => import('../../component/Modals/TeamNameModal'),
  {
    fallback: <SpinnerFullScreen caption="Please wait..." />,
  },
)

const ModifyTitleModal = loadable(
  () => import('../../component/Modals/ModifyTitleModal'),
  {
    fallback: <SpinnerFullScreen caption="Please wait..." />,
  },
)
// const ToolSettings = loadable(() =>
//   pMinDelay(import('../../component/ToolSettings'), 200),
// )
// const ArticleContent = loadable(() => import('../../component/Section/Content'))
const LoadSaveModal = loadable(
  () => import('../../component/Modals/LoadSaveModal'),
  {
    fallback: <SpinnerFullScreen caption="Please wait..." />,
  },
)

// const ToolWhiteBox = styled(Box)`
//   padding: 3rem 0rem;
//   position: relative;
//   @media ${device.medium} {
//     padding: 1rem 0rem 2.5rem;
//   }
//   ${props =>
//     !!props.bgImage &&
//     css`
//       background-position: center;
//       background-size: cover;
//       background-repeat: no-repeat;
//       background-image: url(${props => props.bgImage});
//     `}
// `

const ToolBox = styled(Box)`
  flex-direction: row;
  min-width: ${props =>
    props.fullScreenActive ? 'calc(100% - 26rem)' : '112rem'};
  /* max-width: 130rem; */
  max-width: ${props =>
    props.fullScreenActive ? 'calc(100% - 26rem)' : '132rem'};
  width: 100%;
  justify-content: space-between;
  align-items: stretch;
  @media ${device.medium} {
    flex-direction: column-reverse;
    min-width: 100%;
    padding-left: 1rem;
    padding-right: 1rem;
    align-items: center;
    /* max-width: 56rem; */
  }
`

const ResultBox = styled(Box)`
  /* width: calc((100% - 35rem) / 2); */
  /* width: 47.5rem; */
  margin: 0.7rem 1rem;
  height: ${props => (props.fullScreenActive ? 'auto' : '56rem')};
  flex: ${props => (!props.hiding ? '0 1 47.5rem' : '1 1 47.5rem')};
  margin-right: ${props => (!props.hiding ? '1rem' : '2.5rem')};
  transition: flex 0.5s, margin-right 0.5s;

  /* flex: 1 1 auto; */
  /* min-width: calc((100% - 35rem - 3rem) / 2); */
  /* min-width: 40rem;
  max-width: 48rem; */

  @media ${device.medium} {
    /* max-width: 48rem; */
    width: 100%;
    max-width: 47.5rem;
    margin: 0;
    flex-basis: 56rem;

    /* width: 100%; */
  }
`

// const ResultBox = styled(EqualBox)`
//   /* ${EqualBox} */
//   order: 1;
//   @media ${device.medium} {
//     order: 3;
//   }
// `

// const InputBox = styled(EqualBox)`
//   /* ${EqualBox} */
//   order: 3;
//   @media ${device.medium} {
//     order: 1;
//   }
// `

const ControllerBox = styled(Box)`
  min-width: 27.5rem;
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
  /* margin-right: 0.3rem;
  margin-left: 0.3rem; */
  /* order: 2;
  @media ${device.medium} {
    order: 2;
  } */
`

// const OuterContentBox = styled(Box)`
//   max-width: 110rem;
// `

// const ContentBox = styled(Box)`
//   max-width: 78rem;
// `

// const AdthriveBox = styled(Adthrive)`
//   min-height: 260px;
//   & > div {
//     margin-bottom: 0px;
//   }
//   @media (max-width: 550px) {
//     min-height: 290px;
//   }
// `

// const BGContainer = styled(Box)`
//   background-color: ${props => props.bgColor};
// `

// const ContainerTool = styled(Box)`
//   max-width: 140rem;
//   align-self: center;
//   width: calc(100% - 7rem);
//   margin: 0rem 3.5rem 3.5rem;
//   @media (max-width: 900px) {
//     width: calc(100% - 2rem);
//     margin: 0rem 1rem 3rem;
//   }
// `

const mapState = state => ({
  boardModal: state.rtg.boardModal,
  listModalDisplay: state.modal.listModalDisplay,
  loadSaveModalDisplay: state.modal.loadSaveModalDisplay,
  customTeamModal: state.modal.customTeamModal,
  bgColor: state.settings.bgColor.color,
  people: state.rtg.people,
  savedPeopleList: state.rtg.savedPeopleList,
  bgImage: state.settings.bgImage,
  modifyTitleModal: state.modal.modifyTitleModal,
  presetGroupModal: state.modal.presetGroupModal,
  // getShareLoading: state.async.getShareLoading,
})

const actions = {
  // loadDonorbox,
  // syncFirstPeopleList,
  // getShareLink,
}

class RandomTeamGenerator extends Component {
  state = {
    bgColor: 'var(--bgPlaceholder)',
    modalPreloaded: false,
    bgImage: { on: false, src: null },
  }

  componentDidMount() {
    this.setState({ bgColor: this.props.bgColor, bgImage: this.props.bgImage })

    // const shareId = this.props.search.id
    // if (shareId) {
    //   getPersistor().pause()
    //   const data = {
    //     sharePage: 'rtg',
    //     sharePath: shareId,
    //   }
    //   this.props.getShareLink(data).catch(error => {
    //     getPersistor().persist()
    //     toast.warning(error.error)
    //   })
    // }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.bgColor !== this.props.bgColor) {
      this.setState({ bgColor: this.props.bgColor })
    }
    if (prevState.bgImage !== this.props.bgImage) {
      this.setState({ bgImage: this.props.bgImage })
    }
  }

  preloadModal = () => {
    if (!this.state.modalPreloaded) {
      Modal.preload()
      this.setState({ modalPreloaded: true })
    }
  }

  render() {
    const {
      listModalDisplay,
      boardModal,
      getShareLoading,
      loadSaveModalDisplay,
      customTeamModal,
      handleHideInput,
      handleFullScreen,
      modifyTitleModal,
      presetGroupModal,
    } = this.props
    const { bgColor, bgImage } = this.state
    return (
      <Layout>
        <ResponsiveContext.Consumer>
          {size => {
            return (
              <>
                {loadSaveModalDisplay && (
                  <LoadSaveModal type={loadSaveModalDisplay} page="rtg" />
                )}
                {getShareLoading && (
                  <SpinnerFullScreen caption="Getting share data..." />
                )}
                {listModalDisplay === ToolType.RTG && (
                  <InputListModal size={size} />
                )}
                {customTeamModal && <TeamNameModal />}
                {modifyTitleModal && (
                  <ModifyTitleModal
                    page="rtg"
                    phTitle="Team Picker Wheel"
                    phDescription="Randomize people into groups"
                  />
                )}
                {presetGroupModal && <PresetGroupModal />}
                <BGContainer
                  alignSelf="stretch"
                  justify="center"
                  align="stretch"
                  bgColor={bgColor}
                >
                  {/* <Snowfall
                    snowflakeCount={size === 'medium' ? 60 : 200}
                    radius={[0.5, 5]}
                    speed={[1.0, 3.0]}
                    wind={[-0.5, 1.0]}
                  /> */}
                  {/* <Ezoic
                    align="stretch"
                    alignSelf="center"
                    margin={{ top: "1rem" }}
                    id={EzoicId.aboveTitle}
                  /> */}
                  <FullScreen handle={handleFullScreen}>
                    {boardModal ? <Modal rtgBoard={boardModal} /> : null}
                    <PageTitle
                      page="rtg"
                      title="Team Picker Wheel"
                      caption="Randomize people into groups"
                      fullScreenActive={handleFullScreen.active}
                      bgColor={bgColor}
                    />
                    {/* <Ezoic
                    align="stretch"
                    alignSelf="center"
                    // margin={{ vertical: ".5rem" }}
                    id={EzoicId.aboveTitle}
                  /> */}
                    <ContainerTool fullScreenActive={handleFullScreen.active}>
                      <WheelWhiteBox
                        background="baseBackground"
                        align="center"
                        fullScreenActive={handleFullScreen.active}
                        bgImage={!bgImage.on ? null : replaceCDN(bgImage.src)}
                      >
                        <ToolBox
                          // direction={size === "medium" ? "column-reverse" : "row"}
                          // direction="row"
                          // gap=".5rem"
                          justify="between"
                          fullScreenActive={handleFullScreen.active}
                          // margin={{ horizontal: "3rem" }}
                          // margin={{ top: "2rem" }}
                          // wrap={true}
                        >
                          <ResultBox
                            align="stretch"
                            fullScreenActive={handleFullScreen.active}
                            hiding={
                              handleHideInput.hiding || handleFullScreen.active
                            }
                          >
                            {<Result />}
                          </ResultBox>
                          <ControllerBox
                            flex={{ grow: 0, shrink: 1 }}
                            width="30rem"
                            align="stretch"
                            justify="center"
                            alignSelf="center"
                          >
                            <Controller
                              onStart={this.preloadModal.bind(this)}
                            />
                            {/* <Ezoic
                            alignSelf="center"
                            margin={{ vertical: "2rem" }}
                            id={EzoicId.betweenTool}
                            // height="250px"
                            // width="300px"
                          >
                            <AdsBox
                              adSlot={AdSlot.BetweenTool}
                              adType="betweenTool"
                            />
                          </Ezoic> */}
                          </ControllerBox>
                          <InputBox
                            align="stretch"
                            width="47.5rem"
                            isRTG
                            fullScreenActive={handleFullScreen.active}
                          >
                            <RelativeBox>
                              <Inputs />
                              {handleHideInput.showShield && (
                                <InputShield page="rtg" />
                              )}
                            </RelativeBox>
                          </InputBox>
                        </ToolBox>
                        {/* {!handleFullScreen.active &&
                          !handleHideInput.shareModeActive && ( */}
                        {!handleFullScreen.active && <UnhideInputButton />}
                        <VolumeButton
                          isRTGFullScreen={handleFullScreen.active}
                          bottom="1rem"
                          left="1rem"
                        />
                        <FullScreenButton
                          handleFullScreen={handleFullScreen}
                          position="1rem"
                        />
                        {/* )} */}
                      </WheelWhiteBox>
                    </ContainerTool>
                  </FullScreen>
                  <ContainerTool id="ToolSettingsSection">
                    <MiddleBox />
                    <ToolSettings size={size} page="rtg"></ToolSettings>
                    <Versioning size={size} />
                  </ContainerTool>
                  {/* <Ezoic
                    alignSelf="center"
                    margin={{ bottom: "2rem", top: "1rem" }}
                    id={EzoicId.belowTool}
                  /> */}
                </BGContainer>

                {/* <FeedbackDonateSection size={size} /> */}
                <ArticleContent content="RTGManual" tool="dice" />
                <Footer />
              </>
            )
          }}
        </ResponsiveContext.Consumer>
      </Layout>
    )
  }
}

export default connect(
  mapState,
  actions,
)(withProvider(withWheelToolHOC(RandomTeamGenerator, 'rtg')))

export const Head = () => (
  <SEO
    keywords={[
      'random team generator',
      'random group generator',
      'random list generator',
      'team randomizer',
      'group randomizer',
      'team picker wheel',
    ]}
    title="Team Picker Wheel - Randomize a List of Names into Group"
    description="Team Picker Wheel is a specialized random team generator that can produce random groups from a list of names. Download results in a CSV file or an image."
    tool
    pathname="/tools/random-team-generator/"
    image={RTGSharedImage}
  />
)
